var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilePin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0065 4.03326C18.0049 2.93496 17.1179 2.04345 16.0196 2.03625L11.1292 2.00419C10.5951 2.00069 10.0818 2.21096 9.7037 2.58814L3.02216 9.25267C2.23941 10.0334 2.2386 11.3011 3.02036 12.0829L7.96875 17.0313C8.7498 17.8123 10.0161 17.8123 10.7972 17.0313L17.428 10.4005C17.8038 10.0247 18.0146 9.51478 18.0138 8.98332L18.0065 4.03326ZM14 7.00009C13.4477 7.00009 13 6.55238 13 6.00009C13 5.44781 13.4477 5.00009 14 5.00009C14.5523 5.00009 15 5.44781 15 6.00009C15 6.55238 14.5523 7.00009 14 7.00009Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePin);
export default __webpack_public_path__ + "static/media/file-pin.405c4e87.svg";
export { ForwardRef as ReactComponent };